/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import ILandingPageApiClient from './contracts'
import { IProductCategoryList } from '../LandingPageStateManager/contracts'
import { injectable } from 'inversify'

@injectable()
export class MockLandingPageApiClient implements ILandingPageApiClient {
	productCategoryList!: IProductCategoryList

	/**
	 *
	 */
	constructor() {
		this.productCategoryList = {
			productCategoryList: [
				{
					productCategoryId: 3,
					productCategoryName: 'Billing',
					sequence: 1,
					ProductInfos: [
						{
							code: 'Ease',
							name: 'EASE Medicare',
							sequence: 1,
						},
						{
							code: 'EaseAllPayer',
							name: 'EASE All-Payer',
							sequence: 2,
						},
						{
							code: 'AuditDocs',
							name: 'AUTOMATE esMD',
							sequence: 3,
						},
						{
							code: 'MedicareClaims',
							name: 'CHOICE Medicare Claims',
							sequence: 4,
						},
					],
				},
				{
					productCategoryId: 4,
					productCategoryName: 'Quality',
					sequence: 2,
					ProductInfos: [
						{
							code: 'CareWatch',
							name: 'CAREWATCH',
							sequence: 1,
						},
						{
							code: 'UBWatch',
							name: 'UBWATCH',
							sequence: 2,
						},
						{
							code: 'RiskWatch',
							name: 'RISKWATCH',
							sequence: 3,
						},
					],
				},
				{
					productCategoryId: 6,
					productCategoryName: 'FISSDDE',
					sequence: 3,
					ProductInfos: [
						{
							code: 'ReferralOutgoing',
							name: 'ILLUMINATE Outgoing',
							sequence: 1,
						},
						{
							code: 'ReferralIncoming',
							name: 'ILLUMINATE Incoming',
							sequence: 2,
						},
					],
				},
			],
		} as IProductCategoryList
	}

	getProductCategoryList(): Promise<string> {
		return new Promise<string>(resolve => {
			resolve(JSON.stringify(this.productCategoryList))
		})
	}
}
